import { InspectionType } from '@main-application/inspections/models/rest-inspections-model.interface';
import { IRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';

export const InspectionTypeListConst: IRadioButtonOption<InspectionType>[] = [
  {
    value: InspectionType.MoveOutVacant,
    label: 'Move-out Vacant',
    sort: 0,
    description:
      'A thorough inspection, performed upon resident move in, which documents and establishes a baseline for unit condition.',
  },
  {
    value: InspectionType.CustomInspection,
    label: 'Custom',
    sort: 1,
  },
  {
    value: InspectionType.MoveOutOccupied,
    label: 'Move-out Occupied',
    sort: 2,
    disabled: true,
  },
  {
    value: InspectionType.MoveIn,
    sort: 3,
    label: 'Move-in',
    disabled: true,
  },
  {
    value: InspectionType.Periodic,
    sort: 4,
    label: 'Periodic',
    disabled: true,
  },
  {
    value: InspectionType.Annual,
    sort: 5,
    label: 'Annual',
    disabled: true,
  },
  {
    value: InspectionType.MaintenanceCheck,
    sort: 6,
    label: 'Maintenance',
    disabled: true,
  },
  {
    value: InspectionType.Diligence,
    sort: 7,
    label: 'Diligence',
    disabled: true,
  },
];
